import getSalesOrgBrandsEpic from './getSalesOrgBrandsEpic';
import onUserChangedEpic from './onUserChangedEpic';

const epics = [getSalesOrgBrandsEpic, onUserChangedEpic];

export default epics;
